import React from 'react'
import cx from 'classnames'
import styles from './ScopeChangeRequestBreakdownTable.sass'

export const ScopeChangeRequestBreakdownTable = React.forwardRef(
  (
    { ...rest }: React.HTMLAttributes<HTMLTableElement>,
    ref: React.Ref<HTMLTableElement>,
  ) => {
    return <table ref={ref} className={cx(styles.base)} {...rest}></table>
  },
)
